// extracted by mini-css-extract-plugin
export default {"charityTeaserWrapper":"teaser_charityTeaserWrapper__9mF5Q","charityTeaserWords":"teaser_charityTeaserWords__cQFA0"};